import { render } from "./ImportStudy.vue?vue&type=template&id=0c0681c6&scoped=true"
import script from "./ImportStudy.vue?vue&type=script&lang=js"
export * from "./ImportStudy.vue?vue&type=script&lang=js"

import "./ImportStudy.vue?vue&type=style&index=0&id=0c0681c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0681c6"]])

export default __exports__